import React, { Component } from 'react'
import { Card, Segment, Label, Grid} from 'semantic-ui-react'
import { getCurrentAllianceEvents, getUpcomingAllianceEvents } from '../utility/Firebase'
import { TabbedContainer, TabPane } from './TabbedContainer'
import { GuardianCards } from './Guardians'

import guardianIds from '../assets/json/guardians.json'
import patchNotes from '../assets/json/patch-notes.json'
import news from '../assets/json/news.json'
import { TransitionContainer } from '../utility/GlobalComponents'

const NewGuardiansBanner = ({newGuardians, onClick}) => (
    <Segment className='new-guardian-banner'>
        <Label size='large' attached='top'>
            Featured Guardians
        </Label>
        <GuardianCards
        guardians={newGuardians} 
        onClick={onClick} />
    </Segment>
)

const AllianceEventsBanner = ({upcomingEvents, currentEvents}) => (
    <Segment loading={!upcomingEvents || !currentEvents} className='alliance-events-banner'>
        <Label size='large' attached='top'>
            Alliance Events
        </Label>
        <TabbedContainer defaultActiveIndex={1} panes={
        [
            TabPane('Upcoming', 
            <AllianceEventsContainer events={upcomingEvents} />
            ),
            TabPane('Current', 
            <AllianceEventsContainer events={currentEvents} />
            ),
        ]
    }
    />
    </Segment>
)

const AllianceEventsContainer = ({events}) => (
    <Card.Group className='alliance-events-container'>
        {events?.map((event, index) => 
            <AllianceEventCard key={index} event={event} />
        )}
    </Card.Group>
)

const AllianceEventCard = ({event}) => (
    <Card raised>
        <Card.Content header={event?.name} />
        <Card.Content>
            <Card.Description>
                {event?.description}
            </Card.Description>
        </Card.Content>
        <Card.Content extra>
        {event?.duration}d
        </Card.Content>
  </Card>
)

const PatchNotesBanner = ({patchNotes}) => (
    <Segment className='patches-banner'>
        <Label size='large' attached='top'>
            Patch Notes
        </Label>
        <Segment className='patches-container'>
            {patchNotes?.map((note, index) => 
                <PatchNoteCard key={index} patch={note} />
            )}
        </Segment>
    </Segment>
)

const PatchNoteCard = ({patch}) => (
    <Card fluid className='patch-notes'>
        <Card.Content extra>
            {patch?.v}
        </Card.Content>
        <Card.Content>
            <Card.Description>
                {patch?.description?.map((text, index) => 
                    <p key={index}>{text}</p>
                )}
            </Card.Description>
        </Card.Content>
    </Card>
)

const NewsBanner = ({news}) => (
    <Segment className='news-banner'>
        <Label size='large' attached='top'>
            Mirrorverse-DB News
        </Label>
        <Segment className='news-container'>
            {news?.map((message, index) => 
                 <NewsCard key={index} message={message} />
            )}
        </Segment>
    </Segment>
)

const NewsCard = ({message}) => (
    <Card fluid className='news'>
        <Card.Content>
            <Card.Header>
                {message?.header}
            </Card.Header>
            <Card.Description>
                {message?.description?.map((text, index) => 
                    <p key={index}>{text}</p>
                )}
            </Card.Description>
        </Card.Content>
        <Card.Content extra>
            {message?.extra}
        </Card.Content>
    </Card>
)

export default class Home extends Component {
    state = {
        columns: 2,
        newGuardians: [],
        upcomingEvents: null,
        currentEvents: null
    }

    updateDimensions() {
        let columns = 2
        if (window.innerWidth <= 991) {
          columns = 1
        }
        //  else if (window.innerWidth <= 640 && window.innerWidth > 500) {
        //   count = 2
        // }
  
        this.setState({columns})
      }

    async componentDidMount() {
        this.updateDimensions();
        window.addEventListener("resize", this.updateDimensions.bind(this));

        this.setupNewGuardians()

        await this.setupAllianceEvents()
    }

    setupNewGuardians() {
        const newGuardians = guardianIds.filter(guardian => guardian?.new)

        this.setState({newGuardians})
    }

    async setupAllianceEvents() {
        const upcomingEvents = await getUpcomingAllianceEvents()

        const currentEvents = await getCurrentAllianceEvents()

        this.setState({upcomingEvents, currentEvents})
    }

    openGuardianDetails = (index) => {
        const {newGuardians} = this.state
        const guardian = newGuardians[index]
        window.open(`/guardians/${guardian.id?.toLowerCase()}`, '_blank')
    }

    render() {
        const {columns, newGuardians, upcomingEvents, currentEvents} = this.state
        return (
            <TransitionContainer className='home-container'>
                <Grid columns={columns} className='home-grid'>
                    <Grid.Row stretched className='home-row'>
                        <Grid.Column>
                            <NewsBanner news={news} />
                        </Grid.Column>
                        <Grid.Column> 
                            <PatchNotesBanner patchNotes={patchNotes} />
                        </Grid.Column>
                    </Grid.Row>
                    <Grid.Row stretched className='home-row'>
                        <Grid.Column>
                            <NewGuardiansBanner 
                                newGuardians={newGuardians} 
                                onClick={this.openGuardianDetails.bind(this)} />
                        </Grid.Column>
                        <Grid.Column> 
                            <AllianceEventsBanner
                                upcomingEvents={upcomingEvents}
                                currentEvents={currentEvents} />
                        </Grid.Column>
                    </Grid.Row>
                </Grid>
            </TransitionContainer>
        )
    }
}